import { combineReducers } from 'redux';
import type { Reducer } from 'redux';
import type { RouterState } from 'redux-first-history';
import { reducer as toastrReducer } from 'react-redux-toastr';

// Custom Reducer
import authReducer from './authReducer';
import routesReducer from './routesReducer';
import actionReducer from './actionReducer';
import { commonReducer } from './commonReducer';
import planningReducer from './planningReducer';
import summaryReducer from './summaryReducer';
import userReducer from './userReducer';
import { vehicleReducer } from './vehicleReducer';
import territoryReducer from './territoryReducer';

const rootReducer = (routerReducer: Reducer<RouterState>) => combineReducers({
  router: routerReducer,
  login: authReducer,
  user:userReducer,
  routes: routesReducer,
  actions: actionReducer,
  toastr: toastrReducer,
  planning: planningReducer,
  summaries: summaryReducer,
  core: commonReducer,
  vehicles: vehicleReducer,
  territories: territoryReducer,
});

export default rootReducer;
